import { Injectable } from '@angular/core';

@Injectable()
export class RedirectService {
  /**
   * refirect the page to the given url.
   * @param {string} url
   */
  public redirect(url: string) {
    window.location.href = url;
  }
}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/utilities/services/redirect/redirect.service.ts